import { useEffect } from 'react';

/**
 * Reads a screen again when its tab is looked at once more.
 *
 * A tab left open does not reload on its own, so without this the rows on it stay from whenever
 * they were last read -- overnight, from yesterday. Nothing already on screen is kept while the
 * new read runs: the screen goes back to its loading state and is repainted from the server's
 * answer, the same rule every other read here follows.
 *
 * The session's own day boundary is enforced next to the token, not here. If it has passed, the
 * identity adapter signs the account out on this same event and the screen goes with it.
 */
export function useRereadWhenVisible(reread: () => void) {
  useEffect(() => {
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') reread();
    };
    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => document.removeEventListener('visibilitychange', onVisibilityChange);
  }, [reread]);
}
